import { listStoreBuilder } from '@/main/store/pages/list/builder';

import { NAME, CRUMB_LABEL_KEY } from '../constants';
import { apiProvider } from '../api';

const filter = {
	ProvozovnaId: null as number | null,
	OsobniCis: null as string | null,
	Prijmeni: null as string | null,
	Jmeno: null as string | null,
	TympracId: null as number | null,
	PracovnikOzn: null as string | null,
	ProduktPrp: null as boolean | null,
	VyrazenPrp: false,
	ProvNahl: null as number[] | null,
	ProvAktual: null as number[] | null,
	Sklady: null as number[] | null,
	SkladyNV: null as number[] | null,
	SkladyOV: null as number[] | null,
	SkladyPredm: null as number[] | null,
	SkladyPneu: null as number[] | null,
	PujcovnyVoz: null as number[] | null,
	Pokladny: null as number[] | null,
};


export const store = listStoreBuilder({
	name: NAME,
	apiProvider,
	crumbLabel: CRUMB_LABEL_KEY,
	dropdownList: {
		ProvozovnaId: [],
		TympracId: [],
		PracovnikOzn: [],
		ProvNahl: [],
		ProvAktual: [],
		Sklady: [],
		SkladyNV: [],
		SkladyOV: [],
		SkladyPredm: [],
		SkladyPneu: [],
		PujcovnyVoz: [],
		Pokladny: [],
	},
	filter,
	tableSetting: {},
	rowDetail: null,
	localState: {},
	extraActions: {},
	extraMutations: {},
	extraGetters: {},
	props: {
		filter: {},
		mode: null,
		afterRowSelection: () => {},
	},
});
